<template>
  <div class="card card-1 p-20-px m-b-30 brad-5-px">
     <b-row>
       <b-col cols="4">
          <div class="single-stat initial">
            <h5><span>Currently at</span> Initial</h5>
            <h3><span>{{ stats.initialItems }}</span></h3>
          </div>
       </b-col>
       <b-col cols="4">
          <div class="single-stat printFileSent">
            <h5><span>Currently at</span> Print File Sent</h5>
            <h3><span>{{ stats.printFileSentItems }}</span></h3>
          </div>
       </b-col>
       <b-col cols="4">
          <div class="single-stat printFileChecked">
            <h5><span>Currently at</span> Print File Checked</h5>
            <h3><span>{{ stats.printFileCheckedItems }}</span></h3>
          </div>
       </b-col>
     </b-row>
     <p class="m-t-30 m-b-0 message">We must try to make these numbers Zero. That happens when "Print File Printed" is complete</p>
  </div>
</template>

<script>
  export default {
     props: {
       stats: {
         type: Object,
         default: () => ({})
       }
     }
  }
</script>

<style lang="scss" scoped>
  .single-stat{
    text-align: center;
    h5 span{
      font-size: 13px;
      display: block;
      color: rgb(128, 128, 128);
      margin-bottom: 10px;
    }
    h3{
      width: 110px;
      height: 110px;
      text-align: center;
      line-height: 100px;
      margin: 0 auto;
      border-radius: 50%;
      padding: 5px;
    }
    &.initial h3 span, &.printFileSent h3 span, &.printFileChecked h3 span{
       width: 100px;
       height: 100px;
       display: block;
       border-radius: 50%;
       background-color: black;
       color: #fff;
    }
    &.initial h3 span{
      background-color: #585858;
    }
    &.printFileSent h3 span{
      background-color: #12CBC4; 
    }
    &.printFileChecked h3 span{
      background-color: #F79F1F;
    }

    &.initial h3{
      border: 3px solid #585858;
    }
    &.printFileSent h3{
      border: 3px solid #12CBC4; 
    }
    &.printFileChecked h3{
      border: 3px solid #F79F1F;
    }
  }
  .message{
    font-size: 12px;
    color: rgb(107, 107, 107);
    text-align: center;
  }
</style>